import { useContext, useMemo } from 'react';
import { ActiveChatSessionContext, ChatContextItemsContext } from '@trinity/chat-components/components/Chat/context.js';

export function useIsDigitalTwinLoading(): boolean {
  const contextItems = useContext(ChatContextItemsContext);
  const chat = useContext(ActiveChatSessionContext);

  return useMemo(() => {
    return !contextItems || contextItems.length === 0 || !chat.context;
  }, [contextItems, chat.context]);
}
